import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button/Button';
import PlusIcon from '../../components/Icons/PlusIcon';
import PageTitle from '../../components/Text/PageTitle';
import usePortalConfig from '../../hooks/usePortalConfig/usePortalConfig';
import useRolePermissions from '../../hooks/useRolePermissions/useRolePermissions';
import { reset } from '../../stores/BannersStore';
import BannersTable from './components/BannersTable';

function Banners() {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isUserAllowed } = useRolePermissions();
  const { routePermissions } = usePortalConfig();

  useEffect(() => {
    dispatch(reset());
  }, []);

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <PageTitle>{t('pages.banners.title')}</PageTitle>
        {isUserAllowed(routePermissions.banners) ? (
          <Button
            sx={{ marginLeft: 'auto' }}
            onClick={() => navigate('/banners/create')}
            label={
              <>
                <Box sx={{ marginRight: '0.5rem' }}>
                  <PlusIcon />
                </Box>
                {t('pages.banners.newBanner')}
              </>
            }
          />
        ) : null}
      </Box>
      <BannersTable />
    </>
  );
}

export default Banners;
